const createManualStance = (_id) => ({
  _id,
  text: '',
  textApproved: true,
  sources: [],
  autoSummary: false,
});

export { createManualStance };
